import api from 'api';

export const ASSET_TRANSFER_ASYNC_ACTION_START = 'ASSET_TRANSFER_ASYNC_ACTION_START';
export const ASSET_TRANSFER_ASYNC_ACTION_ERROR = 'ASSET_TRANSFER_ASYNC_ACTION_ERROR';
export const ASSET_TRANSFER_ASYNC_UPDATE_SUCCESS = 'ASSET_TRANSFER_ASYNC_UPDATE_SUCCESS';
export const ASSET_TRANSFER_UPDATE_SUCCESS = 'ASSET_TRANSFER_UPDATE_SUCCESS';
export const ASSET_TRANSFER_RESET_STATE = 'ASSET_TRANSFER_RESET_STATE';
export const ASSET_TRANSFER_SUCCESS_ALERT = 'ASSET_TRANSFER_SUCCESS_ALERT';
export const ASSET_TRANSFER_FAILURE_ALERT = 'ASSET_TRANSFER_FAILURE_ALERT';


function assetTransferAsyncStart() {
  return {
    type: ASSET_TRANSFER_ASYNC_ACTION_START,
  };
}

function assetTransferAsyncUpdateSuccess(data) {
  return {
    type: ASSET_TRANSFER_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function assetTransferAsyncError(error) {
  return {
    type: ASSET_TRANSFER_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetAssetTransferState() {
  return {
    type: ASSET_TRANSFER_RESET_STATE,
  };
}

export function updateAssetTransfer(data) {
  return {
    type: ASSET_TRANSFER_UPDATE_SUCCESS,
    data,
  };
}

export const setAssetTransferSuccessAlertVisibility = (isVisible) => ({
  type: ASSET_TRANSFER_SUCCESS_ALERT,
  payload: isVisible,
});

export const setAssetTransferFailureAlertVisibility = (isVisible) => ({
  type: ASSET_TRANSFER_FAILURE_ALERT,
  payload: isVisible,
});

export function createAssetTransferAsync(assetTransfer) {
  return (dispatch, getState) => {  
    dispatch(assetTransferAsyncStart());
    return api.request('assets/transfers', 'post',assetTransfer)
    .then((data) => {
      dispatch(assetTransferAsyncUpdateSuccess(data));
    })
    .catch((err) => {
      dispatch(assetTransferAsyncError('Unable to create asset transfer'));
      throw (err);
    });
  };
}


export function getAssetTransferAsync() {
  return (dispatch, getState) => {
    dispatch(assetTransferAsyncStart());
    return api.request(`assets/transfers`, 'get')
    .then((data) => {
      dispatch(assetTransferAsyncUpdateSuccess(data));
    })
    .catch((err) => {
      dispatch(assetTransferAsyncError('Unable to get asset transfers'));
      throw (err);
    });
  };
}

export function getTransfersInProgressCount() {
  return () => {
    return api.request(`assets/transfers/in-progress-count`, 'get')
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw (err);
    });
  };
}

export function isAssetTransferWithinThreshold() {
  return (dispatch, getState) => {
    return dispatch(getTransfersInProgressCount())
      .then(count => {
        const threshold = getState().selectiveTransfer.get('assetTransferAllowedCount');
        return count > threshold;
      })
      .catch(err => {
        throw (err);
      });
  };
}
